import ContractDetailSummary from './contract-disabled-summary.entity';

export default class ContractSummary {
  active: number;

  billingDisabled: number;

  canceled: number;

  canceledWithActiveInstance: number;

  canceledWithInactiveInstanceAndHasConsume: number;

  canceledAtCompetence: number;

  inactive: number;

  inactiveWithActiveInstance: number;

  inactiveWithInactiveInstanceAndHasConsume: number;

  inactivatedAtCompetence: number;

  inconsistentContracts: number;

  activeWithContractExpireIn: number;

  inactiveWithContractExpireIn: number;

  billingDisabledDetailed: ContractDetailSummary[];

  inconsistentContractsDetailed: ContractDetailSummary[];

  constructor(obj: any = {}) {
    this.active = obj.active || 0;
    this.billingDisabled = obj.billingDisabled || 0;
    this.canceled = obj.canceled || 0;
    this.canceledWithActiveInstance = obj.canceledWithActiveInstance || 0;
    this.canceledWithInactiveInstanceAndHasConsume = obj.canceledWithInactiveInstanceAndHasConsume
      || 0;
    this.canceledAtCompetence = obj.canceledAtCompetence || 0;
    this.inactive = obj.inactive || 0;
    this.inactiveWithActiveInstance = obj.inactiveWithActiveInstance || 0;
    this.inactiveWithInactiveInstanceAndHasConsume = obj.inactiveWithInactiveInstanceAndHasConsume
     || 0;
    this.inactivatedAtCompetence = obj.inactivatedAtCompetence || 0;
    this.inconsistentContracts = obj.inconsistentContracts || 0;
    this.activeWithContractExpireIn = obj.activeWithContractExpireIn || 0;
    this.inactiveWithContractExpireIn = obj.inactiveWithContractExpireIn || 0;
    this.billingDisabledDetailed = obj.billingDisabledDetailed || [];
    this.inconsistentContractsDetailed = obj.inconsistentContractsDetailed || [];
  }

  public static of(obj: any = {}): ContractSummary {
    return new ContractSummary(obj);
  }

  public static ofList(list: any[] = []): ContractSummary[] {
    return list.map(this.of);
  }
}
